module.exports = __webpack_public_path__ + "static/socials-f4274f05b4fa49cdfb432645357482c1.mp4";